import {useGetUserInfo} from "api/api-hooks/user-hooks";
import {
    IUserStatisticsComponentProps,
    preProcessJobData,
    preProcessUserData, ProcessedJobData,
    ProcessedUserData,
    secondsToHm
} from "components/pages/users-statistics-dashboard/stats-utils";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import React, {useEffect, useState} from "react";


function UserStatisticsDatatable({userSessionData, groupBy, jobTitleFilter}: IUserStatisticsComponentProps) {

    const [userTableData, setUserTableData] = useState<ProcessedUserData[]>();
    const [jobTableData, setJobTableData] = useState<ProcessedJobData[]>();

    useEffect(() => {
        setUserTableData(preProcessUserData(userSessionData));
    }, [userSessionData, jobTitleFilter]);

    useEffect(() => {
        setJobTableData(preProcessJobData(userTableData, groupBy, jobTitleFilter));
    }, [userTableData, groupBy, jobTitleFilter]);

    const totalTimeBodyTemplate = (rowData: any) => {
        return secondsToHm(rowData.totalSessionTime);

    };
    const userBodyTemplate = (rowData: any) => {
        const userInfo = useGetUserInfo(rowData.user);
        return userInfo.data?.displayName;
    };
    const averageTimeBodyTemplate = (rowData: any) => {
        return secondsToHm(rowData.averageSessionDuration);
    };

    const isGroupedByJob = groupBy === "jobTitle";

    return (
        <div className="mt-2">
            <DataTable value={isGroupedByJob ? jobTableData : userTableData} removableSort size="small" scrollable
                       scrollHeight="350px">
                {!isGroupedByJob && <Column field="user" header="User" body={userBodyTemplate}/>}
                <Column field="jobTitle" header="Job Title"/>
                <Column field="totalSessionTime" header="Total time logged in" body={totalTimeBodyTemplate} sortable/>
                <Column field="averageSessionDuration" header="Average time logged in" body={averageTimeBodyTemplate}
                        sortable/>
                <Column field="totalSessions" header="Login count" sortable/>
                <Column field="activeDaysCount" header="Active Days" sortable/>
            </DataTable>
        </div>

    );

}

export default UserStatisticsDatatable;